/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { lg } = boxShadows;
const { size } = typography;
const { text, white, transparent, light, dark, gradients } = colors.light;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    popper: ({ theme }) => ({
      boxShadow: lg,
      padding: pxToRem(8),
      fontSize: size.sm,
      color: text.main,
      textAlign: "left",
      backgroundColor:
        theme.palette.mode === "dark" ? "#1a2332 !important" : `${white.main} !important`,
      borderRadius: borderRadius.md,
    }),

    paper: {
      boxShadow: "none",
      backgroundColor: transparent.main,
    },

    option: ({ theme }) => ({
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: theme.palette.mode === "dark" ? "rgba(255,255,255,0.85)" : text.main,
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.1)" : light.main,
        color: theme.palette.mode === "dark" ? "rgba(255,255,255,0.95)" : dark.main,
      },

      '&[aria-selected="true"]': {
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.1) !important"
            : `${light.main} !important`,
        color:
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.95) !important"
            : `${dark.main} !important`,
      },
    }),

    noOptions: {
      fontSize: size.sm,
      color: text.main,
    },

    groupLabel: {
      color: dark.main,
    },

    loading: {
      fontSize: size.sm,
      color: text.main,
    },

    tag: {
      display: "flex",
      alignItems: "center",
      height: "auto",
      padding: pxToRem(4),
      backgroundColor: gradients.dark.state,
      color: white.main,

      "& .MuiChip-label": {
        lineHeight: 1.2,
        padding: `0 ${pxToRem(10)} 0 ${pxToRem(4)}`,
      },

      "& .MuiSvgIcon-root, & .MuiSvgIcon-root:hover, & .MuiSvgIcon-root:focus": {
        color: white.main,
        marginRight: 0,
      },
    },
  },
};
